module.exports = __webpack_public_path__ + "img/safe-center-logo.adf6d785.jpg";